// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"real-estate_wrapper__8S_rA","clients":"real-estate_clients__B0cLm","notification":"real-estate_notification__YS1lt","clients_title":"real-estate_clients_title__LxYw6"};